import React from 'react'
import PropTypes from 'prop-types'

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`kpi-tabpanel-${index}`}
      aria-labelledby={`kpi-tab-${index}`}
      {...other}
    >
      {
        value === index && (
          <>
            {children}
          </>
        )
      }
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.any,
  index: PropTypes.any
}

export default TabPanel